import { FaFacebook, FaInstagram, FaWhatsapp } from 'react-icons/fa'
import React from 'react'

const Footer = () => {

  const scrollTo = (elementId) => {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
      });
    }
  };

  return (
    <footer className='w-full bottom-0 flex lg:px-32 flex-col gap-2 bg-gray-500 text-white justify-between'>
      {/* <div className='divider h-[1px] bg-black'></div> */}
      <div className="py-4 flex lg:flex-row flex-col gap-8 items-center">
        <a href='#home' onClick={() => scrollTo('home')} className='text-xl font-bold'>ANHS © {new Date().getFullYear()}</a>
        <div className="flex gap-5 justify-center text-center lg:flex-row flex-col lg:ml-auto lg:mr-10 ml-0">
        <a href='#aboutus'>About Us</a>
        <a href='#services'>Services</a>
        <a href='#payment'>Payment</a> 
        <a href='#feedback'>Feedback</a> 
        <a href='#contact'>Contact Us</a>
        </div>
        <div className="flex gap-3 justify-end item-end lg:ml-auto lg:mr-10">
          {/* <Link style={{ paddingRight: 15 }} to='https://www.linkedin.com' target='_blank'><FontAwesomeIcon icon={faLinkedin} size='2x' /></Link> */}
          {/* {/* <Link to='https://instagram.com/waspoenergy?igshid=MzRlODBiNWFlZA==' target='_blank'><FontAwesomeIcon icon={faInstagram} size='2x' /></Link> */}
          <a href='https://www.facebook.com/profile.php?id=100066425392476' target='_blank' rel='noreferrer'><FaFacebook size={20} /></a> 
          <a href='https://www.instagram.com/andrenacouzihomeschool?igsh=MXUxcWsxbDM4MXVhaQ==' target='_blank' rel='noreferrer'><FaInstagram size={20} /></a> 
          <a href='https://wa.me/+96176909514' className='lg:block hidden' target='_blank' rel='noreferrer'><FaWhatsapp size={20} /></a> 
        </div>
      </div>
    </footer>
  )
}

export default Footer